export enum Role {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export enum Position {
  ATTORNEY = 'ATTORNEY',
  CHIEF_ATTORNEY = 'CHIEF_ATTORNEY',
  AUDITOR = 'AUDITOR',
  CLERK = 'CLERK',
  SECRETARY = 'SECRETARY',
  STAFF = 'STAFF',
}

export enum GeoLevel {
  NATIONAL = 'NATIONAL',
  STATE = 'STATE',
  DISTRICT = 'DISTRICT',
  TOWNSHIP = 'TOWNSHIP',
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  LOCKED = 'LOCKED',
}


export type DepartmentType = 
  | 'ATTORNEY_GENERAL' 
  | 'CIVIL' 
  | 'CRIMINAL' 
  | 'LEGAL_ADVISORY' 
  | 'LITIGATION' 
  | 'PROSECUTION' 
  | 'ADMINISTRATION' 
  | 'FINANCE' 
  | 'HUMAN_RESOURCE' 
  | 'TRAINING';